module.exports = __webpack_public_path__ + "static/SpaRepairLogoLight-f224af14632a5f78455b542bbe72b21e.svg";